import React from "react"
import { observer, useLocalObservable } from "mobx-react"
import { Flex } from "antd"
import { choose } from "choose-matching"

import { NoContent } from "@src/app/components/NoContent/Index"
import { SubMerchCollection } from "@src/pages/settingsTeam/classes/SubMerchCollections"
import { SubMerchForm } from "@src/pages/settingsTeam/ui/SubMerchForm"
import { SubMerchTable } from "@src/pages/settingsTeam/ui/SubMerchTable"

export const SettingsTeam = observer(() => {
  const collection = useLocalObservable(() => new SubMerchCollection())
  return (
    <Flex gap={32} vertical>
      <SubMerchForm />

      {choose(
        [
          collection.isLoading || !collection.isEmpty,
          <SubMerchTable collection={collection}></SubMerchTable>,
        ],
        [
          collection.isEmpty,
          <NoContent title="No Team Member">
            <span />
          </NoContent>,
        ],
      )}
    </Flex>
  )
})
